import type { z } from 'zod'
import type { Logger } from '~/interfaces/Logger'

/** Keeps names that exactly match the schema's vocabulary; logs and drops the rest. */
export function parseVocabularyNames<T extends string>(
  schema: z.ZodType<T>,
  names: readonly string[],
  logger: Logger,
  operation: string
): T[] {
  const known: T[] = []
  for (const name of names) {
    const parsed = schema.safeParse(name)
    if (parsed.success) known.push(parsed.data)
    else logger.warn(operation, { name })
  }
  return known
}
